import React, { useState, useEffect } from 'react'

import { UserFilter, ContractStatusFilter, SortOrder } from '../FilterTypes'

type Props = {
    stage: string
    criteriaContractStatus?: ContractStatusFilter

    onClosePopup: (value: boolean) => void
    onAcceptFilter: () => void

    // Фильтрация по столбцу "Статус договора"
    onChangeFilterSettingCriteriaContractStatusSort: (value: SortOrder) => void
    onChangeFilterSettingCriteriaContractStatus: (
        values: string[] | null
    ) => void
}

const PopupMenuContractStatus: React.FC<Props> = (props) => {
    const [selectedValues, setSelectedValues] = useState<string[]>(
        props.criteriaContractStatus?.values || []
    )

    // При обновлении критериев родителя синхронизируем локальное состояние
    useEffect(() => {
        setSelectedValues(props.criteriaContractStatus?.values || [])
    }, [props.criteriaContractStatus])

    // Функция для переключения выбранного значения
    const toggleValue = (value: string) => {
        let newSelected = [...selectedValues]

        if (props.stage == 'Исполнение договора') {
            if (newSelected.includes(value)) {
                newSelected = newSelected.filter((v) => v !== value)
            } else {
                newSelected.push(value)
            }
        } else if (props.stage == 'Договор закрыт') {
            if (newSelected.includes(value)) {
                newSelected = newSelected.filter((v) => v !== value)
            } else {
                newSelected.push(value)
            }
        } else {
            if (newSelected.includes(value)) {
                newSelected = newSelected.filter((v) => v !== value)
            } else {
                newSelected.push(value)
            }
        }

        // Если массив пустой, result будет равен null
        const result = newSelected.length === 0 ? null : newSelected

        // Локальное состояние оставляем как массив, чтобы UI корректно обновлялся
        setSelectedValues(newSelected)
        console.log(newSelected)
        props.onChangeFilterSettingCriteriaContractStatus(result)
    }

    const selectAllValues = () => {
        if (props.stage == 'Исполнение договора') {
            const allValues = [
                'Договор на исполнении',
                'Просрочен',
                'Осталось меньше 10 дней',
                'Осталось меньше 5 дней',
                'Возможно исполнен',
            ]
            setSelectedValues(allValues)
            console.log(allValues)
            props.onChangeFilterSettingCriteriaContractStatus(allValues)
        } else if (props.stage == 'Договор закрыт') {
            const allValues = [
                'Исполнение договора завершено',
                'Договор расторгнут',
                'Исполнение договора прекращено',
            ]
            setSelectedValues(allValues)
            console.log(allValues)
            props.onChangeFilterSettingCriteriaContractStatus(allValues)
        } else {
            const allValues = [
                'Договор на исполнении',
                'Просрочен',
                'Исполнение договора завершено',
                'Договор расторгнут',
                'Исполнение договора прекращено',
                'Осталось меньше 10 дней',
                'Осталось меньше 5 дней',
                'Возможно исполнен',
            ]
            setSelectedValues(allValues)
            console.log(allValues)
            props.onChangeFilterSettingCriteriaContractStatus(allValues)
        }
    }
    return (
        <div className="absolute left-0 my-2 w-64 origin-top-right rounded-[10px] shadow-md shadow-[#18181830] z-10 bg-[#d9dce0] dark:bg-[#333033] border border-[#b8b8b8] dark:border-[#696769]">
            <div className="p-1">
                {/* Блок с чекбоксами */}
                {props.stage == 'Исполнение договора' ? (
                    <div className="flex flex-col gap-1">
                        <label
                            className="flex items-center p-1 hover:bg-[#e9e9e9] dark:hover:bg-[#656365] cursor-pointer rounded-lg"
                            onClick={(e) => {
                                e.stopPropagation()
                                toggleValue('Договор на исполнении')
                            }}
                        >
                            <input
                                type="checkbox"
                                className="form-checkbox h-4 w-4"
                                checked={selectedValues.includes(
                                    'Договор на исполнении'
                                )}
                                readOnly
                                onClick={(e) => e.stopPropagation()} // предотвращаем повторное срабатывание
                            />
                            <span className="ml-2 text-[12.8px] text-[#181818] dark:text-[#FFFFFF]">
                                Договор на исполнении
                            </span>
                        </label>
                        <label
                            className="flex items-center p-1 hover:bg-[#e9e9e9] dark:hover:bg-[#656365] cursor-pointer rounded-lg"
                            onClick={(e) => {
                                e.stopPropagation()
                                toggleValue('Осталось меньше 10 дней')
                            }}
                        >
                            <input
                                type="checkbox"
                                className="form-checkbox h-4 w-4"
                                checked={selectedValues.includes(
                                    'Осталось меньше 10 дней'
                                )}
                                readOnly
                                onClick={(e) => e.stopPropagation()} // предотвращаем повторное срабатывание
                            />
                            <span className="ml-2 text-[12.8px] text-[#181818] dark:text-[#FFFFFF]">
                                Осталось меньше 10 дней
                            </span>
                        </label>
                        <label
                            className="flex items-center p-1 hover:bg-[#e9e9e9] dark:hover:bg-[#656365] cursor-pointer rounded-lg"
                            onClick={(e) => {
                                e.stopPropagation()
                                toggleValue('Осталось меньше 5 дней')
                            }}
                        >
                            <input
                                type="checkbox"
                                className="form-checkbox h-4 w-4"
                                checked={selectedValues.includes(
                                    'Осталось меньше 5 дней'
                                )}
                                readOnly
                                onClick={(e) => e.stopPropagation()} // предотвращаем повторное срабатывание
                            />
                            <span className="ml-2 text-[12.8px] text-[#181818] dark:text-[#FFFFFF]">
                                Осталось меньше 5 дней
                            </span>
                        </label>
                        <label
                            className="flex items-center p-1 hover:bg-[#e9e9e9] dark:hover:bg-[#656365] cursor-pointer rounded-lg"
                            onClick={(e) => {
                                e.stopPropagation()
                                toggleValue('Возможно исполнен')
                            }}
                        >
                            <input
                                type="checkbox"
                                className="form-checkbox h-4 w-4"
                                checked={selectedValues.includes(
                                    'Возможно исполнен'
                                )}
                                readOnly
                                onClick={(e) => e.stopPropagation()} // предотвращаем повторное срабатывание
                            />
                            <span className="ml-2 text-[12.8px] text-[#181818] dark:text-[#FFFFFF]">
                                Возможно исполнен
                            </span>
                        </label>
                        <label
                            className="flex items-center p-1 hover:bg-[#e9e9e9] dark:hover:bg-[#656365] cursor-pointer rounded-lg"
                            onClick={(e) => {
                                e.stopPropagation()
                                toggleValue('Просрочен')
                            }}
                        >
                            <input
                                type="checkbox"
                                className="form-checkbox h-4 w-4"
                                checked={selectedValues.includes('Просрочен')}
                                readOnly
                                onClick={(e) => e.stopPropagation()} // предотвращаем повторное срабатывание
                            />
                            <span className="ml-2 text-[12.8px] text-[#181818] dark:text-[#FFFFFF]">
                                Просрочен
                            </span>
                        </label>
                    </div>
                ) : props.stage == 'Договор закрыт' ? (
                    <div className="flex flex-col gap-1">
                        <label
                            className="flex items-center p-1 hover:bg-[#e9e9e9] dark:hover:bg-[#656365] cursor-pointer rounded-lg"
                            onClick={(e) => {
                                e.stopPropagation()
                                toggleValue('Исполнение договора завершено')
                            }}
                        >
                            <input
                                type="checkbox"
                                className="form-checkbox h-4 w-4"
                                checked={selectedValues.includes(
                                    'Исполнение договора завершено'
                                )}
                                readOnly
                                onClick={(e) => e.stopPropagation()} // предотвращаем повторное срабатывание
                            />
                            <span className="ml-2 text-[12.8px] text-[#181818] dark:text-[#FFFFFF]">
                                Исполнение договора завершено
                            </span>
                        </label>
                        <label
                            className="flex items-center p-1 hover:bg-[#e9e9e9] dark:hover:bg-[#656365] cursor-pointer rounded-lg"
                            onClick={(e) => {
                                e.stopPropagation()
                                toggleValue('Договор расторгнут')
                            }}
                        >
                            <input
                                type="checkbox"
                                className="form-checkbox h-4 w-4"
                                checked={selectedValues.includes(
                                    'Договор расторгнут'
                                )}
                                readOnly
                                onClick={(e) => e.stopPropagation()} // предотвращаем повторное срабатывание
                            />
                            <span className="ml-2 text-[12.8px] text-[#181818] dark:text-[#FFFFFF]">
                                Договор расторгнут
                            </span>
                        </label>
                        <label
                            className="flex items-center p-1 hover:bg-[#e9e9e9] dark:hover:bg-[#656365] cursor-pointer rounded-lg"
                            onClick={(e) => {
                                e.stopPropagation()
                                toggleValue('Исполнение договора прекращено')
                            }}
                        >
                            <input
                                type="checkbox"
                                className="form-checkbox h-4 w-4"
                                checked={selectedValues.includes(
                                    'Исполнение договора прекращено'
                                )}
                                readOnly
                                onClick={(e) => e.stopPropagation()} // предотвращаем повторное срабатывание
                            />
                            <span className="ml-2 text-[12.8px] text-[#181818] dark:text-[#FFFFFF]">
                                Исполнение договора прекращено
                            </span>
                        </label>
                    </div>
                ) : props.stage == 'Реестр договоров' ? (
                    <div className="flex flex-col gap-1">
                        <label
                            className="flex items-center p-1 hover:bg-[#e9e9e9] dark:hover:bg-[#656365] cursor-pointer rounded-lg"
                            onClick={(e) => {
                                e.stopPropagation()
                                toggleValue('Договор на исполнении')
                            }}
                        >
                            <input
                                type="checkbox"
                                className="form-checkbox h-4 w-4"
                                checked={selectedValues.includes(
                                    'Договор на исполнении'
                                )}
                                readOnly
                                onClick={(e) => e.stopPropagation()} // предотвращаем повторное срабатывание
                            />
                            <span className="ml-2 text-[12.8px] text-[#181818] dark:text-[#FFFFFF]">
                                Договор на исполнении
                            </span>
                        </label>
                        <label
                            className="flex items-center p-1 hover:bg-[#e9e9e9] dark:hover:bg-[#656365] cursor-pointer rounded-lg"
                            onClick={(e) => {
                                e.stopPropagation()
                                toggleValue('Осталось меньше 10 дней')
                            }}
                        >
                            <input
                                type="checkbox"
                                className="form-checkbox h-4 w-4"
                                checked={selectedValues.includes(
                                    'Осталось меньше 10 дней'
                                )}
                                readOnly
                                onClick={(e) => e.stopPropagation()} // предотвращаем повторное срабатывание
                            />
                            <span className="ml-2 text-[12.8px] text-[#181818] dark:text-[#FFFFFF]">
                                Осталось меньше 10 дней
                            </span>
                        </label>
                        <label
                            className="flex items-center p-1 hover:bg-[#e9e9e9] dark:hover:bg-[#656365] cursor-pointer rounded-lg"
                            onClick={(e) => {
                                e.stopPropagation()
                                toggleValue('Осталось меньше 5 дней')
                            }}
                        >
                            <input
                                type="checkbox"
                                className="form-checkbox h-4 w-4"
                                checked={selectedValues.includes(
                                    'Осталось меньше 5 дней'
                                )}
                                readOnly
                                onClick={(e) => e.stopPropagation()} // предотвращаем повторное срабатывание
                            />
                            <span className="ml-2 text-[12.8px] text-[#181818] dark:text-[#FFFFFF]">
                                Осталось меньше 5 дней
                            </span>
                        </label>
                        <label
                            className="flex items-center p-1 hover:bg-[#e9e9e9] dark:hover:bg-[#656365] cursor-pointer rounded-lg"
                            onClick={(e) => {
                                e.stopPropagation()
                                toggleValue('Возможно исполнен')
                            }}
                        >
                            <input
                                type="checkbox"
                                className="form-checkbox h-4 w-4"
                                checked={selectedValues.includes(
                                    'Возможно исполнен'
                                )}
                                readOnly
                                onClick={(e) => e.stopPropagation()} // предотвращаем повторное срабатывание
                            />
                            <span className="ml-2 text-[12.8px] text-[#181818] dark:text-[#FFFFFF]">
                                Возможно исполнен
                            </span>
                        </label>
                        <label
                            className="flex items-center p-1 hover:bg-[#e9e9e9] dark:hover:bg-[#656365] cursor-pointer rounded-lg"
                            onClick={(e) => {
                                e.stopPropagation()
                                toggleValue('Просрочен')
                            }}
                        >
                            <input
                                type="checkbox"
                                className="form-checkbox h-4 w-4"
                                checked={selectedValues.includes('Просрочен')}
                                readOnly
                                onClick={(e) => e.stopPropagation()} // предотвращаем повторное срабатывание
                            />
                            <span className="ml-2 text-[12.8px] text-[#181818] dark:text-[#FFFFFF]">
                                Просрочен
                            </span>
                        </label>
                        <label
                            className="flex items-center p-1 hover:bg-[#e9e9e9] dark:hover:bg-[#656365] cursor-pointer rounded-lg"
                            onClick={(e) => {
                                e.stopPropagation()
                                toggleValue('Исполнение договора завершено')
                            }}
                        >
                            <input
                                type="checkbox"
                                className="form-checkbox h-4 w-4"
                                checked={selectedValues.includes(
                                    'Исполнение договора завершено'
                                )}
                                readOnly
                                onClick={(e) => e.stopPropagation()} // предотвращаем повторное срабатывание
                            />
                            <span className="ml-2 text-[12.8px] text-[#181818] dark:text-[#FFFFFF]">
                                Исполнение договора завершено
                            </span>
                        </label>
                        <label
                            className="flex items-center p-1 hover:bg-[#e9e9e9] dark:hover:bg-[#656365] cursor-pointer rounded-lg"
                            onClick={(e) => {
                                e.stopPropagation()
                                toggleValue('Договор расторгнут')
                            }}
                        >
                            <input
                                type="checkbox"
                                className="form-checkbox h-4 w-4"
                                checked={selectedValues.includes(
                                    'Договор расторгнут'
                                )}
                                readOnly
                                onClick={(e) => e.stopPropagation()} // предотвращаем повторное срабатывание
                            />
                            <span className="ml-2 text-[12.8px] text-[#181818] dark:text-[#FFFFFF]">
                                Договор расторгнут
                            </span>
                        </label>
                        <label
                            className="flex items-center p-1 hover:bg-[#e9e9e9] dark:hover:bg-[#656365] cursor-pointer rounded-lg"
                            onClick={(e) => {
                                e.stopPropagation()
                                toggleValue('Исполнение договора прекращено')
                            }}
                        >
                            <input
                                type="checkbox"
                                className="form-checkbox h-4 w-4"
                                checked={selectedValues.includes(
                                    'Исполнение договора прекращено'
                                )}
                                readOnly
                                onClick={(e) => e.stopPropagation()} // предотвращаем повторное срабатывание
                            />
                            <span className="ml-2 text-[12.8px] text-[#181818] dark:text-[#FFFFFF]">
                                Исполнение договора прекращено
                            </span>
                        </label>
                    </div>
                ) : (
                    ''
                )}

                <div className="flex flex-row w-full px-4 text-[11px] text-left items-center justify-end mt-1">
                    <label
                        className="w-full text-[11px] text-left text-sky-600 hover:text-sky-400 hover:underline cursor-pointer"
                        onClick={() => {
                            selectAllValues()
                        }}
                    >
                        Выделить все
                    </label>
                    <label
                        className="w-full text-[11px] text-right text-sky-600 hover:text-sky-400 hover:underline cursor-pointer"
                        onClick={() => {
                            props.onChangeFilterSettingCriteriaContractStatus(
                                null
                            )
                        }}
                    >
                        Сбросить
                    </label>
                </div>

                {/* Разделитель */}
                <hr className="mt-3 mx-4 border-[#b8b8b8] dark:border-[#464447]" />

                <div className="flex flex-col w-full gap-1 mt-3">
                    {/* Заголовок сортировки и кнопки сортировки */}
                    <div className="px-4 text-[11px] text-left text-[#6A6A6A] dark:text-[#8A8A8A]">
                        Сортировка
                    </div>
                    {/* Разделитель */}
                    <button
                        className="flex flex-row w-full text-left p-1 hover:bg-[#e9e9e9] dark:hover:bg-[#656365] text-[12.8px] text-[#181818] dark:text-[#FFFFFF] rounded-lg items-center"
                        onClick={() => {
                            props.onChangeFilterSettingCriteriaContractStatusSort(
                                'asc'
                            )
                        }}
                    >
                        <svg
                            className="w-3 h-3"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            id="signal-alt"
                        >
                            <g transform="rotate(90 12 12)">
                                <path
                                    fill={`${props.criteriaContractStatus?.sort_order == 'asc' ? '#0284c7' : '#8A8A8A'}`}
                                    d="M10,14a1,1,0,0,0-1,1v6a1,1,0,0,0,2,0V15A1,1,0,0,0,10,14ZM5,18a1,1,0,0,0-1,1v2a1,1,0,0,0,2,0V19A1,1,0,0,0,5,18ZM20,2a1,1,0,0,0-1,1V21a1,1,0,0,0,2,0V3A1,1,0,0,0,20,2ZM15,9a1,1,0,0,0-1,1V21a1,1,0,0,0,2,0V10A1,1,0,0,0,15,9Z"
                                ></path>
                            </g>
                        </svg>
                        <span className="ml-2 text-[12.8px] text-[#181818] dark:text-[#FFFFFF]">
                            По возрастанию
                        </span>
                    </button>
                    <button
                        className="flex flex-row w-full text-left p-1 hover:bg-[#e9e9e9] dark:hover:bg-[#656365] text-[12.8px] text-[#181818] dark:text-[#FFFFFF] rounded-lg items-center"
                        onClick={() => {
                            props.onChangeFilterSettingCriteriaContractStatusSort(
                                'desc'
                            )
                        }}
                    >
                        <svg
                            className="w-3 h-3"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            id="signal-alt"
                        >
                            <g transform="translate(24,0) scale(-1,1)">
                                <g transform="rotate(-90 12 12)">
                                    <path
                                        fill={`${props.criteriaContractStatus?.sort_order == 'desc' ? '#0284c7' : '#8A8A8A'}`}
                                        d="M10,14a1,1,0,0,0-1,1v6a1,1,0,0,0,2,0V15A1,1,0,0,0,10,14ZM5,18a1,1,0,0,0-1,1v2a1,1,0,0,0,2,0V19A1,1,0,0,0,5,18ZM20,2a1,1,0,0,0-1,1V21a1,1,0,0,0,2,0V3A1,1,0,0,0,20,2ZM15,9a1,1,0,0,0-1,1V21a1,1,0,0,0,2,0V10A1,1,0,0,0,15,9Z"
                                    ></path>
                                </g>
                            </g>
                        </svg>
                        <span className="ml-2 text-[12.8px] text-[#181818] dark:text-[#FFFFFF]">
                            По убыванию
                        </span>
                    </button>
                </div>

                <div className="flex w-full px-4 text-[11px] text-left items-center justify-end">
                    <label
                        className="w-fit text-[11px] text-left text-sky-600 hover:text-sky-400 hover:underline cursor-pointer"
                        onClick={() => {
                            props.onChangeFilterSettingCriteriaContractStatusSort(
                                null
                            )
                        }}
                    >
                        Сбросить
                    </label>
                </div>

                <div className="flex flex-col w-full mt-3 items-start justify-center">
                    <button
                        className="flex h-6 flex-col w-full gap-1 text-left text-[12.8px] rounded-[10px] items-center justify-center shadow-md shadow-[#18181830] text-[#181818] dark:text-[#FFFFFF] bg-[#F6F6F6] hover:bg-[#FFFFFF] dark:bg-[#494849] dark:hover:bg-[#656365]"
                        onClick={() => {
                            props.onAcceptFilter()
                            props.onClosePopup(false)
                        }}
                    >
                        Сохранить
                    </button>
                </div>
            </div>
        </div>
    )
}

export default PopupMenuContractStatus
